// @flow

import type {AccountKeys} from 'docs/data';
import type {MerchantKeysRequestModel} from 'docs/types';

export const transformMerchantKeys = (
  model: MerchantKeysRequestModel,
): AccountKeys => ({
  publishable: model.publishable,
  secret: model.secret,
});
